import { render } from "./QueueEntryView.vue?vue&type=template&id=1076d1ff&scoped=true&ts=true"
import script from "./QueueEntryView.vue?vue&type=script&lang=ts"
export * from "./QueueEntryView.vue?vue&type=script&lang=ts"

import "./QueueEntryView.vue?vue&type=style&index=0&id=1076d1ff&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1076d1ff"]])

export default __exports__